module.exports = __webpack_public_path__ + "media/stylesheets/images/icn-4ad0ca1554d3fdbfd9bf0dab91016ce6.svg";